import { Button } from "../ui/button";
import { Input } from "../ui/input";
import DateInput from "../DateInput";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Download, Pencil, Trash2, Save, X, Plus } from "lucide-react";

const METODI_USCITA = ["Contante", "POS", "Bonifico", "Carta di Credito"];

export const RegistroUscite = ({
  usciteFiltrate,
  totaleUsciteFiltrate,
  registroUsciteCount,
  tipologieUscita,
  sottotipologieUscita,
  fornitori,
  filtroTipologia,
  filtroSottotipologia,
  filtroFornitore,
  filtroMetodo,
  filtroBanca,
  banche,
  onFiltroTipologiaChange,
  onFiltroSottotipologiaChange,
  onFiltroFornitoreChange,
  onFiltroMetodoChange,
  onFiltroBancaChange,
  getBancaNome,
  editUscita,
  editUscitaForm,
  onStartEditUscita,
  onSaveEditUscita,
  onCancelEditUscita,
  onEditUscitaFormChange,
  onDeleteTarget,
  onExport,
  onNewFornitore,
  loadingRegistro,
  formatDateIT,
  getTipologiaNome,
  getSottotipologiaNome,
  getFornitoreNome
}) => (
  <div className="bg-card backdrop-blur-sm border border-border rounded-2xl overflow-hidden">
    <div className="p-4 pb-2">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <h3 className="text-base font-semibold text-red-400">Registro Uscite</h3>
        <div className="flex flex-wrap items-center gap-2">
          <Select value={filtroTipologia} onValueChange={onFiltroTipologiaChange}>
            <SelectTrigger className="h-8 w-32 text-xs bg-card border-border text-foreground" data-testid="expense-type-filter">
              <SelectValue placeholder="Tipologia" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Tutte</SelectItem>
              {tipologieUscita.map((t) => (
                <SelectItem key={t.id} value={t.id}>{t.nome}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={filtroSottotipologia} onValueChange={onFiltroSottotipologiaChange}>
            <SelectTrigger data-testid="expense-subtype-filter" className="h-8 w-40 text-xs bg-card border-border text-foreground"><SelectValue placeholder="Sotto-tipologia" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Tutte le sotto-tipologie</SelectItem>
              <SelectItem value="__none__">Senza sotto-tipologia</SelectItem>
              {sottotipologieUscita.filter(s => filtroTipologia === "__all__" || s.tipologia_id === filtroTipologia).map(s => <SelectItem key={s.id} value={s.id}>{filtroTipologia === "__all__" ? `${getTipologiaNome(s.tipologia_id)} · ` : ""}{s.nome}</SelectItem>)}
            </SelectContent>
          </Select>
          
          <Select value={filtroFornitore} onValueChange={onFiltroFornitoreChange}>
            <SelectTrigger className="h-8 w-36 text-xs bg-card border-border text-foreground">
              <SelectValue placeholder="Fornitore" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Tutti</SelectItem>
              {fornitori.map((f) => (
                <SelectItem key={f.id} value={f.id}>{f.ragione_sociale}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          <Select value={filtroMetodo} onValueChange={onFiltroMetodoChange}>
            <SelectTrigger className="h-8 w-32 text-xs bg-card border-border text-foreground">
              <SelectValue placeholder="Metodo" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Tutti</SelectItem>
              {METODI_USCITA.map((m) => (
                <SelectItem key={m} value={m}>{m}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={filtroBanca} onValueChange={onFiltroBancaChange}>
            <SelectTrigger className="h-8 w-36 text-xs bg-card border-border text-foreground" data-testid="expense-bank-filter">
              <SelectValue placeholder="Banca" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Tutte le banche</SelectItem>
              <SelectItem value="__generic__">Generico</SelectItem>
              {banche.map((bank) => (
                <SelectItem key={bank.id} value={bank.id}>{bank.nome}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          <Button data-testid="expense-export-button" variant="outline" size="sm" onClick={onExport} className="border-border text-foreground hover:bg-accent hover:text-accent-foreground">
            <Download className="h-4 w-4 mr-1" />
            Excel
          </Button>
        </div>
      </div>
      
      <div className="mt-3 p-3 bg-red-500/10 rounded-xl border border-red-500/20">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-red-400">
            Totale {(filtroTipologia !== "__all__" || filtroSottotipologia !== "__all__" || filtroFornitore !== "__all__" || filtroMetodo !== "__all__" || filtroBanca !== "__all__") ? "Filtrato" : "Periodo"}
          </span>
          <span className="text-xl font-bold text-red-400" data-testid="totale-uscite">
            € {totaleUsciteFiltrate.toFixed(2)}
          </span>
        </div>
        {(filtroTipologia !== "__all__" || filtroSottotipologia !== "__all__" || filtroFornitore !== "__all__" || filtroMetodo !== "__all__" || filtroBanca !== "__all__") && (
          <div className="text-xs text-red-400/60 mt-1">
            {usciteFiltrate.length} voci su {registroUsciteCount} totali
          </div>
        )}
      </div>
    </div>
    <div className="p-0">
      {loadingRegistro ? (
        <div className="p-8 text-center text-muted-foreground">Caricamento...</div>
      ) : usciteFiltrate.length === 0 ? (
        <div className="p-8 text-center text-muted-foreground">Nessuna uscita nel periodo</div>
      ) : (
        <div className="overflow-x-auto">
          <Table className="[&_td]:py-1 [&_th]:py-1">
            <TableHeader>
              <TableRow className="bg-red-500/10 border-b border-border">
                <TableHead className="w-20 text-xs text-foreground/70">Data</TableHead>
                <TableHead className="w-20 text-right text-xs text-foreground/70">Costo</TableHead>
                <TableHead className="w-24 text-xs text-foreground/70">Come</TableHead>
                <TableHead className="w-28 text-xs text-foreground/70">Banca</TableHead>
                <TableHead className="w-24 text-xs text-foreground/70">Tipologia</TableHead>
                <TableHead className="text-xs text-foreground/70">Fornitore</TableHead>
                <TableHead className="text-xs text-foreground/70">Descrizione</TableHead>
                <TableHead className="w-16 text-center text-xs text-foreground/70">Azioni</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {usciteFiltrate.map((item) => (
                <TableRow key={item.id} className="hover:bg-card border-b border-white/5">
                  {editUscita?.id === item.id ? (
                    <>
                      <TableCell className="py-1">
                        <DateInput value={editUscitaForm.data} onChange={(v) => onEditUscitaFormChange({ ...editUscitaForm, data: v })} />
                      </TableCell>
                      <TableCell className="py-1">
                        <Input type="number" step="0.01" value={editUscitaForm.importo} onChange={(e) => onEditUscitaFormChange({ ...editUscitaForm, importo: e.target.value })} className="h-7 w-20 text-right text-xs bg-card border-border text-foreground" />
                      </TableCell>
                      <TableCell className="py-1">
                        <Select value={editUscitaForm.metodo} onValueChange={(v) => onEditUscitaFormChange({ ...editUscitaForm, metodo: v })}>
                          <SelectTrigger className="h-7 w-24 text-xs bg-card border-border text-foreground"><SelectValue /></SelectTrigger>
                          <SelectContent>
                            {METODI_USCITA.map((m) => (<SelectItem key={m} value={m}>{m}</SelectItem>))}
                          </SelectContent>
                        </Select>
                      </TableCell>
                      <TableCell className="py-1 text-xs text-foreground/70">{getBancaNome(item)}</TableCell>
                      <TableCell className="py-1">
                        <Select value={editUscitaForm.tipologia_id} onValueChange={(v) => onEditUscitaFormChange({ ...editUscitaForm, tipologia_id: v, sottotipologia_id: null })}>
                          <SelectTrigger data-testid={`edit-expense-type-${item.id}`} className="h-7 w-32 text-xs bg-card border-border text-foreground"><SelectValue /></SelectTrigger>
                          <SelectContent>
                            {tipologieUscita.map((t) => (<SelectItem key={t.id} value={t.id}>{t.nome}</SelectItem>))}
                          </SelectContent>
                        </Select>
                        <Select value={editUscitaForm.sottotipologia_id || "none"} onValueChange={v => onEditUscitaFormChange({ ...editUscitaForm, sottotipologia_id: v === "none" ? null : v })}>
                          <SelectTrigger data-testid={`edit-expense-subtype-${item.id}`} className="h-7 w-32 mt-1 text-xs bg-card border-border text-foreground"><SelectValue placeholder="Sotto-tipologia" /></SelectTrigger>
                          <SelectContent><SelectItem value="none">Nessuna</SelectItem>{sottotipologieUscita.filter(s => s.tipologia_id === editUscitaForm.tipologia_id).map(s => <SelectItem key={s.id} value={s.id}>{s.nome}</SelectItem>)}</SelectContent>
                        </Select>
                      </TableCell>
                      <TableCell className="py-1">
                        <Select value={editUscitaForm.fornitore_id || "none"} onValueChange={(v) => {
                          if (v === "__new__") {
                            onNewFornitore();
                          } else {
                            onEditUscitaFormChange({ ...editUscitaForm, fornitore_id: v === "none" ? "" : v });
                          }
                        }}>
                          <SelectTrigger className="h-7 w-28 text-xs bg-card border-border text-foreground"><SelectValue /></SelectTrigger>
                          <SelectContent>
                            <SelectItem value="none">-</SelectItem>
                            {fornitori.map((f) => (<SelectItem key={f.id} value={f.id}>{f.ragione_sociale}</SelectItem>))}
                            <SelectItem value="__new__" className="text-lime-400"><Plus className="h-3 w-3 inline mr-1" />Nuovo</SelectItem>
                          </SelectContent>
                        </Select>
                      </TableCell>
                      <TableCell className="py-1">
                        <Input value={editUscitaForm.descrizione} onChange={(e) => onEditUscitaFormChange({ ...editUscitaForm, descrizione: e.target.value })} className="h-7 text-xs bg-card border-border text-foreground" />
                      </TableCell>
                      <TableCell className="py-1">
                        <div className="flex justify-center gap-0.5">
                          <Button size="icon" variant="ghost" onClick={onSaveEditUscita} className="h-6 w-6"><Save className="h-3 w-3 text-lime-400" /></Button>
                          <Button size="icon" variant="ghost" onClick={onCancelEditUscita} className="h-6 w-6"><X className="h-3 w-3 text-muted-foreground" /></Button>
                        </div>
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell className="font-mono text-xs text-foreground">{formatDateIT(item.data, true)}</TableCell>
                      <TableCell className="text-right text-xs font-semibold text-red-400">€ {item.importo.toFixed(2)}</TableCell>
                      <TableCell className="text-xs text-foreground/70">{item.metodo}</TableCell>
                      <TableCell className="text-xs text-foreground/70" data-testid={`expense-bank-${item.id}`}>{getBancaNome(item)}</TableCell>
                      <TableCell className="text-xs text-foreground/70" data-testid={`expense-classification-${item.id}`}>{getTipologiaNome(item.tipologia_id)}{item.sottotipologia_id && <span className="block text-[11px] text-rose-700 dark:text-rose-300" data-testid={`expense-subtype-${item.id}`}>↳ {getSottotipologiaNome(item.sottotipologia_id)}</span>}</TableCell>
                      <TableCell className="text-xs text-foreground/70">{getFornitoreNome(item.fornitore_id)}</TableCell>
                      <TableCell className="text-muted-foreground text-xs truncate max-w-[200px]">{item.descrizione || "-"}</TableCell>
                      <TableCell>
                        <div className="flex justify-center gap-0.5">
                          <Button size="icon" variant="ghost" onClick={() => onStartEditUscita(item)} className="h-6 w-6"><Pencil className="h-3 w-3 text-muted-foreground" /></Button>
                          <Button size="icon" variant="ghost" onClick={() => onDeleteTarget({ type: 'uscite', id: item.id })} className="h-6 w-6"><Trash2 className="h-3 w-3 text-red-400" /></Button>
                        </div>
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  </div>
);
